import { memo } from 'react';
import {
  Banner as PolarisBanner,
  BannerProps as PolarisBannerProps,
  BlockStack,
  Box,
  BoxProps,
  SkeletonDisplayText,
} from '@shopify/polaris';
import SupportLink from './SupportLink';

export type BannerProps = PolarisBannerProps & {
  hidden?: boolean;
  isLoading?: boolean;
  boxComponentProps?: BoxProps;
};

const BasicBanner: React.FC<BannerProps> = ({
  children,
  hidden = false,
  isLoading = false,
  boxComponentProps,
  ...bannerProps
}) => {
  if (hidden) {
    return null;
  }
  if (isLoading) {
    return <SkeletonDisplayText maxWidth="100%" />;
  }

  return (
    <Box {...boxComponentProps}>
      <PolarisBanner {...bannerProps}>
        {bannerProps.tone === 'critical' || bannerProps.tone === 'warning' ? (
          <BlockStack gap="200">
            {children}
            <SupportLink />
          </BlockStack>
        ) : (
          children
        )}
      </PolarisBanner>
    </Box>
  );
};

export default memo(BasicBanner);
